import React, { useRef, useState, useCallback, useEffect } from 'react'

import {
    Box,
} from '@mui/material';

import { useNavigate, Link } from 'react-router-dom';

import DateFilter from '@inovua/reactdatagrid-community/DateFilter'

import CommonBreadcumbs from "../common/CommonBreadcumbs"
import DataGridToolbar from '../common/DataGridToolbar';
import DataGridTable from '../common/DataGridTable';
import CommonRestricted from '../common/CommonRestricted';
import DataGridRowActionMenu from '../common/DataGridRowActionMenu';

import { icons } from '../common/CommonIcons';
import { useCustomFields, customFieldModules, customFieldFunctions } from '../../hooks/api/useCustomFields';
import { useSystemPrompt } from '../../hooks/useSystemPrompt';
import { useDataGridParams } from '../../hooks/useDataGridParams';
import { useSystemRoutes, routeTypes } from '../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../hooks/usePermissions';
import { useTranslations } from '../../hooks/useTranslations';

export default function ListCustomFields({
    routeType
}) {
    const { t } = useTranslations({ ns: ["common"] })

    const navigate = useNavigate();

    const { promptMessage } = useSystemPrompt();
    const { list, remove } = useCustomFields({ customFieldModule: customFieldModules.item, customFieldFunction: customFieldFunctions.item.item });

    const [selectedIds, setSelectedIds] = useState([])
    const [refreshDataGrid, setRefreshDataGrid] = useState(0)
    const { defineColumns, columns, filterValues, getRenderColumnLink, getRenderColumnBooleanDisplay, getRenderColumnTextDisplay } = useDataGridParams('id')
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.customField.id, scopeTypes.customField.customField.id)

    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)

    const gridRef = React.createRef();

    const resetDataGridTableSelection = () => {
        setSelectedIds([])
    }

    const fetchData = async (props) => {

        resetDataGridTableSelection();

        try {

            const result = await list(props)

            return {
                data: result?.data?.custom_fields,
                count: result?.data?.total
            }

        } catch (error) {

            promptMessage(false, `Error getting results (${error?.message})`)

            return {
                data: [],
                count: 0
            }
        }

    }

    useEffect(() => {

        defineColumnsView()

    }, [])

    const defineColumnsView = () => {
        defineColumns([

            {
                name: 'field_key',
                header: t('key'),
                renderValue: ({ value, cellProps }) => {

                    if (isPermissionAllow({ functionType: functionTypes.pageUpdate.id }) === false) {
                        return getRenderColumnTextDisplay(value)
                    }

                    let path = getRoute(`settings/customField/update/${cellProps.data.id}`);

                    return getRenderColumnLink(path, value)

                }
            },
            {
                name: 'field_module',
                header: t('module')
            },
            {
                name: 'module_function',
                header: t('function')
            },
            {
                name: 'field_name',
                header: t('name')
            },
            {
                name: 'field_label',
                header: t('label')
            },
            {
                name: 'field_type',
                header: t('type')
            },

            {
                name: 'status',
                header: t('status'),
                defaultFlex: 1,
                showColumnMenuTool: false,
                // rendervalue: ({ value }) => {
                //     return value == 1? "ACTIVE" : "IN-ACTIVE"
                // }
                renderValue: ({ cellProps, value }) => getRenderColumnBooleanDisplay(value, [t("enabled"), t("disabled")], ["primary", "default"], "")
            },
        ])
    }

    const handleDelete = async () => {

        try {
            let result = await remove({ ids: selectedIds })

            promptMessage(true, result?.message)
            setRefreshDataGrid(val => val + 1)

        } catch (error) {
            promptMessage(false, error?.message)
        }

    }

    const RenderToolbar = () => {

        const getToolbarMainMenus = () => {

            let props = [];

            if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
                props.push({
                    displayIconName: icons.plus,
                    onClick: () => {
                        navigate(getRoute("settings/customField/new"));
                    }
                })
            }

            return props
        }

        const getActionOnClick = () => {

            let handleFunction = null

            if (isPermissionAllow({ functionType: functionTypes.remove.id })) {
                handleFunction = handleDelete
            }

            return handleFunction
        }

        return (
            <DataGridToolbar
                selectedRowCount={
                    selectedIds.length
                }
                mainMenus={
                    getToolbarMainMenus()
                }
                actionOnClickRemove={
                    getActionOnClick()
                }
                actionMenus={[]}
            />
        )
    }

    const RenderDataGridTable = () => {

        return (
            <DataGridTable
                ref={gridRef}
                refresh={refreshDataGrid}
                fetchData={fetchData}
                dataGrid={{
                    idProperty: "id",
                    style: {
                        minHeight: 600
                    },
                    pageSizes: [20, 50, 100],
                    defaultLimit: 10,
                    defaultSkip: 0,
                    checkboxColumn:
                        isPermissionAllow({ functionType: functionTypes.remove.id }),
                    columns,
                    defaultFilterValue: filterValues,
                    onSelectionChange: (items) => {
                        setSelectedIds(
                            items
                        )
                    }
                }}

            />
        )
    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.customFields })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("customFields")}
                // pageSubTitle="customers in your system"
                breadcrumbs={[
                    {
                        displayText: t("customFields"),
                        props: {
                            // underline: "hover",
                            // href: "/"
                        }
                    }
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageList.id }) ?
                    <>
                        {
                            RenderToolbar()
                        }
                        {
                            RenderDataGridTable()
                        }
                    </>
                    :
                    (
                        <CommonRestricted />
                    )
            }

        </Box>
    )
}
